export const categories = [
  { id: 'live', name: '直播圈', slug: 'live', desc: '打赏、连麦、直播间承诺与主播合约纠纷的第一手材料', icon: 'ri-live-line' },
  { id: 'commerce', name: '带货电商', slug: 'commerce', desc: '坑位费、保底条款、真实成交与售后争议的凭据梳理', icon: 'ri-shopping-bag-3-line' },
  { id: 'video', name: '短视频达人', slug: 'video', desc: '流量注水、剧本摆拍、账号归属等视频证据对照', icon: 'ri-video-line' },
  { id: 'music', name: '音乐与综艺', slug: 'music', desc: '翻唱授权、节目剪辑争议与沟通录音还原', icon: 'ri-music-2-line' },
  { id: 'mcn', name: 'MCN与合同', slug: 'mcn', desc: '分成比例、解约条件、补充协议的照片与原件核对', icon: 'ri-file-text-line' },
  { id: 'brand', name: '品牌商务', slug: 'brand', desc: '广告投放、坑位结算、商务沟通往来记录汇总', icon: 'ri-briefcase-4-line' },
];

export const evidenceTypes = [
  { key: 'audio', name: '录音', icon: 'ri-mic-line', desc: '通话与现场录音，附时长与关键时间点' },
  { key: 'video', name: '视频证据', icon: 'ri-film-line', desc: '直播录屏、现场视频，标注关键帧对照' },
  { key: 'contract', name: '合同照片', icon: 'ri-file-paper-2-line', desc: '协议关键页照片，敏感信息已做遮挡处理' },
  { key: 'transfer', name: '转账记录', icon: 'ri-exchange-dollar-line', desc: '收款凭证与流水，金额与时间可逐笔核对' },
];

export const evidenceLabelMap = {
  audio: '录音',
  video: '视频证据',
  contract: '合同照片',
  transfer: '转账记录',
} as const;

export type EvidenceKey = 'audio' | 'video' | 'contract' | 'transfer';

export type CaseItem = {
  id: string;
  slug: string;
  title: string;
  categoryId: string;
  evidence: EvidenceKey[];
  summary: string;
  cover: string;
  coverAlt: string;
  author: string;
  publishDate: string;
  readTime: string;
  views: string;
  status: '已核实' | '审核中' | '待回应';
  featured: boolean;
  tags: string[];
  timeline: { date: string; title: string; desc: string }[];
  evidenceItems: { key: EvidenceKey; title: string; desc: string; meta: string }[];
  related: string[];
};

export const cases: CaseItem[] = [
  {
    id: 'c001',
    slug: 'food-blogger-revenue-split-audio',
    title: '头部美食博主与机构分成纠纷：三段谈判录音浮出水面',
    categoryId: 'commerce',
    evidence: ['audio', 'contract'],
    summary:
      '事件源于一份署名日期与生效日期不一致的分成协议。投稿人提供了三段共约 52 分钟的谈判录音，以及协议关键页照片，双方对"保底服务费是否包含在分成内"说法不一。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20editorial%20still%20life%20of%20a%20printed%20contract%20document%20beside%20a%20voice%20recorder%20on%20a%20wooden%20desk%2C%20soft%20natural%20window%20light%2C%20muted%20amber%20tones%2C%20clean%20minimal%20background%2C%20investigative%20magazine%20photography&width=800&height=450&seq=baoliao-food-split&orientation=landscape',
    coverAlt: '分成纠纷事件相关的合同文件与录音设备静物照片',
    author: '实锤整理组',
    publishDate: '2026-08-28',
    readTime: '6 分钟',
    views: '18.2 万',
    status: '已核实',
    featured: true,
    tags: ['分成纠纷', '谈判录音', '协议生效日'],
    timeline: [
      { date: '2025-11', title: '双方签约', desc: '签约时约定服务期一年，分成比例按阶段浮动。' },
      { date: '2026-03', title: '首轮结算争议', desc: '博主方认为保底服务费应计入成本，机构方持相反意见。' },
      { date: '2026-06', title: '谈判录音产生', desc: '三次线下沟通被完整录音，共约 52 分钟。' },
      { date: '2026-08', title: '材料公开', desc: '投稿人整理时间线并提交协议关键页照片。' },
    ],
    evidenceItems: [
      { key: 'audio', title: '第一次谈判录音', desc: '双方就首季度结算口径进行沟通，可听到对保底条款的不同解释。', meta: '18 分 40 秒 · 关键点 06:12 / 14:35' },
      { key: 'audio', title: '第三次沟通录音', desc: '机构方提出补充方案，博主方要求书面确认未获回应。', meta: '21 分 05 秒 · 关键点 09:20' },
      { key: 'contract', title: '协议第 4 页照片', desc: '分成条款全文，签署日期与生效日期存在差异。', meta: '照片 2 张 · 隐私信息已遮挡' },
    ],
    related: ['c004', 'c007', 'c010'],
  },
  {
    id: 'c002',
    slug: 'game-streamer-transfer-records',
    title: '游戏主播"夜行者"转会风波：聊天记录与转账凭证对不上',
    categoryId: 'live',
    evidence: ['transfer', 'contract', 'video'],
    summary:
      '围绕一笔转会费的去向，投稿人提交了 9 笔转账记录与一段连麦录屏。转账时间与聊天记录中承诺的时间点存在明显偏差，差额部分至今没有说明。',
    cover:
      'https://readdy.ai/api/search-image?query=moody%20dark%20editorial%20scene%20with%20a%20glowing%20computer%20screen%20showing%20generic%20transaction%20list%20on%20a%20desk%20at%20night%2C%20deep%20red%20rim%20light%2C%20cinematic%20shallow%20depth%20of%20field%2C%20investigative%20technology%20mood&width=800&height=450&seq=baoliao-streamer-transfer&orientation=landscape',
    coverAlt: '主播转会事件相关的转账记录界面与录屏画面',
    author: '实锤整理组',
    publishDate: '2026-08-24',
    readTime: '5 分钟',
    views: '15.7 万',
    status: '待回应',
    featured: true,
    tags: ['转会费', '转账差额', '连麦录屏'],
    timeline: [
      { date: '2026-02', title: '口头达成转会意向', desc: '双方在连麦中确认转会费分两期支付。' },
      { date: '2026-04', title: '首期到账', desc: '首期款项到账时间晚于约定一周。' },
      { date: '2026-07', title: '尾款争议', desc: '投稿人称尾款金额与约定不符。' },
    ],
    evidenceItems: [
      { key: 'transfer', title: '9 笔转账记录', desc: '逐笔列出金额与时间，其中 2 笔备注为"借款"。', meta: '合计 4 笔为约定款项 · 金额已做区间处理' },
      { key: 'video', title: '连麦录屏节选', desc: '可听到对支付时间的口头承诺。', meta: '时长 4 分 12 秒 · 关键点 01:48' },
      { key: 'contract', title: '意向协议照片', desc: '未加盖公章的意向书，约定条款较简略。', meta: '照片 1 张' },
    ],
    related: ['c001', 'c008', 'c012'],
  },
  {
    id: 'c003',
    slug: 'beauty-livestream-scripted-review',
    title: '美妆达人直播间"剧本式打假"？现场视频逐帧对比',
    categoryId: 'live',
    evidence: ['video'],
    summary:
      '有观众发现同一款产品在两场直播中的"检测结果"完全相反。投稿人提交了完整录屏并按时间点做逐帧对照，提出了对直播流程真实性的疑问。',
    cover:
      'https://readdy.ai/api/search-image?query=clean%20beauty%20editorial%20still%20life%20with%20pink%20cosmetic%20bottles%20and%20a%20small%20ring%20light%20on%20a%20pale%20marble%20surface%2C%20soft%20diffused%20lighting%2C%20muted%20rose%20and%20cream%20palette%2C%20minimal%20background&width=800&height=450&seq=baoliao-beauty-live&orientation=landscape',
    coverAlt: '美妆直播间剧本争议相关的产品与灯光静物照片',
    author: '实锤整理组',
    publishDate: '2026-08-20',
    readTime: '4 分钟',
    views: '12.3 万',
    status: '审核中',
    featured: false,
    tags: ['直播录屏', '逐帧对照', '产品质疑'],
    timeline: [
      { date: '2026-05-12', title: '第一场直播', desc: '直播中展示某款产品检测结果并给出评价。' },
      { date: '2026-06-30', title: '第二场直播', desc: '对同款产品给出相反结论。' },
      { date: '2026-08', title: '录屏提交', desc: '观众整理两场录屏时间点并投稿。' },
    ],
    evidenceItems: [
      { key: 'video', title: '两场直播录屏', desc: '按检测环节逐帧对照，展示结论差异。', meta: '合成视频 6 分 05 秒' },
    ],
    related: ['c011', 'c009', 'c005'],
  },
  {
    id: 'c004',
    slug: 'mcn-owing-split-seven-transfers',
    title: 'MCN机构被曝拖欠分成：主播晒出七笔转账记录',
    categoryId: 'mcn',
    evidence: ['transfer', 'contract'],
    summary:
      '投稿人公开了七笔来自机构的转账，金额均低于合同约定比例。投稿人认为部分款项系"无备注冲抵"，但机构方未提供结算明细。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20flat%20lay%20of%20financial%20receipts%20and%20calculator%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20top%20light%2C%20neat%20organized%20documents%2C%20muted%20amber%20and%20stone%20tones%2C%20business%20magazine%20style&width=800&height=450&seq=baoliao-mcn-owe&orientation=landscape',
    coverAlt: '拖欠分成事件相关的收款凭证与结算单据照片',
    author: '实锤整理组',
    publishDate: '2026-08-16',
    readTime: '5 分钟',
    views: '11.1 万',
    status: '已核实',
    featured: false,
    tags: ['拖欠分成', '结算明细', '收款凭证'],
    timeline: [
      { date: '2025-09', title: '合作开始', desc: '合同约定按月结算广告分成。' },
      { date: '2026-01', title: '首笔到账延迟', desc: '延迟约 20 天后到账。' },
      { date: '2026-07', title: '连续拖欠', desc: '连续三个月金额低于约定比例。' },
    ],
    evidenceItems: [
      { key: 'transfer', title: '七笔收款记录', desc: '按月份排列，标注每月实际到账金额。', meta: '2026-01 至 2026-07' },
      { key: 'contract', title: '分成条款照片', desc: '合同第 3 页明确分成基数与结算周期。', meta: '照片 2 张 · 已遮挡账号信息' },
    ],
    related: ['c001', 'c007', 'c008'],
  },
  {
    id: 'c005',
    slug: 'food-explore-data-inflation',
    title: '百万粉丝探店账号"数据注水"：后台截图与保底条款冲突',
    categoryId: 'video',
    evidence: ['contract', 'video'],
    summary:
      '投稿人对比了合作前后发布的探店视频播放数据与后台截图，认为存在集中异常增长。同时，合同中约定的保底播放量与公开数据存在出入。',
    cover:
      'https://readdy.ai/api/search-image?query=overhead%20shot%20of%20a%20smartphone%20showing%20generic%20analytics%20charts%20resting%20on%20a%20cafe%20table%20with%20coffee%20and%20notebook%2C%20warm%20afternoon%20light%2C%20muted%20earth%20tones%2C%20editorial%20lifestyle%20photography&width=800&height=450&seq=baoliao-data-inflate&orientation=landscape',
    coverAlt: '探店账号数据争议相关的后台数据截图与合同照片',
    author: '实锤整理组',
    publishDate: '2026-08-11',
    readTime: '6 分钟',
    views: '9.8 万',
    status: '审核中',
    featured: false,
    tags: ['数据异常', '保底条款', '后台截图'],
    timeline: [
      { date: '2026-03', title: '签订探店合作', desc: '约定发布 3 条内容与保底播放量。' },
      { date: '2026-04', title: '数据集中增长', desc: '发布后 2 小时内播放量异常集中上涨。' },
      { date: '2026-08', title: '截图投稿', desc: '投稿人提供后台截图与合同照片。' },
    ],
    evidenceItems: [
      { key: 'contract', title: '保底条款照片', desc: '合同中约定保底播放量及未达标补偿方式。', meta: '照片 1 张' },
      { key: 'video', title: '数据变化录屏', desc: '展示 2 小时内的播放量曲线。', meta: '录屏 3 分 30 秒' },
    ],
    related: ['c003', 'c007', 'c011'],
  },
  {
    id: 'c006',
    slug: 'music-cover-license-audio',
    title: '音乐区UP主翻唱授权争议：沟通录音曝光双方说法',
    categoryId: 'music',
    evidence: ['audio'],
    summary:
      '围绕一首翻唱作品的商业使用授权，投稿人公布了一段沟通录音。录音中对于"是否允许商用"的表述前后不一致，双方随后各执一词。',
    cover:
      'https://readdy.ai/api/search-image?query=atmospheric%20music%20studio%20corner%20with%20headphones%20and%20a%20microphone%20on%20a%20dark%20wood%20console%2C%20warm%20amber%20accent%20light%2C%20soft%20bokeh%20background%2C%20moody%20editorial%20still%20life&width=800&height=450&seq=baoliao-music-license&orientation=landscape',
    coverAlt: '翻唱授权争议相关的录音室设备照片',
    author: '实锤整理组',
    publishDate: '2026-08-06',
    readTime: '4 分钟',
    views: '8.4 万',
    status: '待回应',
    featured: false,
    tags: ['翻唱授权', '商用许可', '沟通录音'],
    timeline: [
      { date: '2026-04', title: '作品发布', desc: '翻唱作品上线并用于商业合作。' },
      { date: '2026-05', title: '授权质疑', desc: '权利方提出未授权商用。' },
      { date: '2026-07', title: '沟通录音产生', desc: '双方就授权范围电话沟通。' },
    ],
    evidenceItems: [
      { key: 'audio', title: '授权沟通录音', desc: '可听到关于商用范围的答复。', meta: '时长 12 分 18 秒 · 关键点 04:50' },
    ],
    related: ['c003', 'c010', 'c009'],
  },
  {
    id: 'c007',
    slug: 'lowprice-slotfee-contract',
    title: '带货"低价神话"调查：坑位费合同照片与真实成交额',
    categoryId: 'commerce',
    evidence: ['contract', 'transfer'],
    summary:
      '品牌方投稿称，主播方宣传的"全网最低价"与实际到手价不符，且直播实际成交额远低于合同承诺。投稿人提供了合同照片与两笔服务费转账。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20shipping%20boxes%20and%20a%20price%20tag%20on%20a%20clean%20studio%20table%20with%20soft%20neutral%20lighting%2C%20muted%20red%20and%20cream%20accents%2C%20commerce%20magazine%20photography%2C%20minimal%20background&width=800&height=450&seq=baoliao-slotfee&orientation=landscape',
    coverAlt: '坑位费争议相关的合同与小票静物照片',
    author: '实锤整理组',
    publishDate: '2026-08-02',
    readTime: '5 分钟',
    views: '7.6 万',
    status: '已核实',
    featured: false,
    tags: ['坑位费', '承诺成交', '服务费'],
    timeline: [
      { date: '2026-05', title: '签订直播合作', desc: '合同约定坑位费与预估成交额。' },
      { date: '2026-06', title: '直播执行', desc: '实际成交额低于预估。' },
      { date: '2026-07', title: '协商退款未果', desc: '品牌方要求按合同补偿未达成一致。' },
    ],
    evidenceItems: [
      { key: 'contract', title: '坑位费合同照片', desc: '含服务费金额与预估成交条款。', meta: '照片 3 张' },
      { key: 'transfer', title: '两笔服务费转账', desc: '对应合同约定的两期款项。', meta: '金额已做区间处理' },
    ],
    related: ['c001', 'c004', 'c005'],
  },
  {
    id: 'c008',
    slug: 'shortdrama-actor-termination',
    title: '短剧演员解约风波：一份补充协议改变分成比例',
    categoryId: 'mcn',
    evidence: ['contract'],
    summary:
      '双方对解约后的分成比例各执一词。投稿人提供的补充协议照片显示，分成比例在续约时被调整，但主合同并未同步修改。',
    cover:
      'https://readdy.ai/api/search-image?query=close%20up%20of%20stacked%20printed%20legal%20documents%20with%20a%20pen%20on%20top%2C%20warm%20desk%20lamp%20light%2C%20dark%20muted%20background%2C%20serious%20editorial%20documentary%20mood%2C%20shallow%20depth%20of%20field&width=800&height=450&seq=baoliao-drama-contract&orientation=landscape',
    coverAlt: '解约争议相关的主合同与补充协议文件照片',
    author: '实锤整理组',
    publishDate: '2026-07-28',
    readTime: '5 分钟',
    views: '6.9 万',
    status: '审核中',
    featured: false,
    tags: ['补充协议', '分成比例', '解约'],
    timeline: [
      { date: '2025-10', title: '签署主合同', desc: '约定三年合作与固定分成比例。' },
      { date: '2026-04', title: '续约补充协议', desc: '调整分成比例与解约条件。' },
      { date: '2026-07', title: '提出解约', desc: '双方对适用比例产生分歧。' },
    ],
    evidenceItems: [
      { key: 'contract', title: '补充协议照片', desc: '第 2 页标注新的分成比例。', meta: '照片 2 张 · 已遮挡身份证信息' },
    ],
    related: ['c004', 'c002', 'c010'],
  },
  {
    id: 'c009',
    slug: 'livestream-lottery-unfulfilled',
    title: '直播间"中奖"承诺未兑现：录屏视频与客服录音',
    categoryId: 'live',
    evidence: ['video', 'audio'],
    summary:
      '中奖观众称奖品长期未发放。投稿人提供了当时的直播录屏与一段客服沟通录音，录音中客服对发放时间多次改口。',
    cover:
      'https://readdy.ai/api/search-image?query=colorful%20gift%20boxes%20and%20confetti%20on%20a%20clean%20neutral%20table%20under%20soft%20studio%20light%2C%20muted%20warm%20palette%20with%20small%20red%20accents%2C%20editorial%20still%20life%2C%20minimal%20background&width=800&height=450&seq=baoliao-lottery&orientation=landscape',
    coverAlt: '直播间中奖承诺争议相关的奖品与录屏界面',
    author: '实锤整理组',
    publishDate: '2026-07-23',
    readTime: '4 分钟',
    views: '6.2 万',
    status: '待回应',
    featured: false,
    tags: ['中奖承诺', '客服录音', '奖品发放'],
    timeline: [
      { date: '2026-05-18', title: '直播中奖', desc: '直播中宣布中奖名单与发放时间。' },
      { date: '2026-06', title: '多次询问无果', desc: '客服对发放时间给出不同答复。' },
      { date: '2026-07', title: '材料投稿', desc: '观众提交录屏与通话录音。' },
    ],
    evidenceItems: [
      { key: 'video', title: '直播中奖录屏', desc: '记录中奖环节的完整承诺表述。', meta: '时长 2 分 40 秒' },
      { key: 'audio', title: '客服沟通录音', desc: '三次通话中对发放时间的答复。', meta: '合计 9 分 15 秒' },
    ],
    related: ['c003', 'c006', 'c011'],
  },
  {
    id: 'c010',
    slug: 'family-account-revenue-audio',
    title: '亲子账号商业化争议：出镜分成协商录音流出',
    categoryId: 'mcn',
    evidence: ['audio', 'contract'],
    summary:
      '账号走红后，出镜家庭成员与运营方就分成比例进行协商。投稿人提供了协商录音与一份未签署的草稿协议，指出实际分成与口头承诺不符。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20cozy%20living%20room%20corner%20with%20a%20camera%20on%20tripod%20and%20a%20notebook%20on%20a%20soft%20blanket%2C%20golden%20hour%20light%2C%20muted%20cream%20and%20amber%20tones%2C%20gentle%20editorial%20lifestyle%20photography&width=800&height=450&seq=baoliao-family-account&orientation=landscape',
    coverAlt: '亲子账号分成争议相关的拍摄设备与协议草稿照片',
    author: '实锤整理组',
    publishDate: '2026-07-18',
    readTime: '6 分钟',
    views: '5.8 万',
    status: '审核中',
    featured: false,
    tags: ['出镜分成', '口头承诺', '草稿协议'],
    timeline: [
      { date: '2025-12', title: '账号走红', desc: '单条内容播放量突破百万。' },
      { date: '2026-03', title: '协商分成', desc: '双方就出镜成员分成进行协商。' },
      { date: '2026-07', title: '协商录音流出', desc: '投稿人称实际分成低于口头约定。' },
    ],
    evidenceItems: [
      { key: 'audio', title: '分成协商录音', desc: '涉及口头约定的比例与结算方式。', meta: '时长 16 分 02 秒 · 关键点 08:14' },
      { key: 'contract', title: '未签署草稿协议', desc: '草稿中的比例与最终执行不一致。', meta: '照片 1 张' },
    ],
    related: ['c008', 'c004', 'c001'],
  },
  {
    id: 'c011',
    slug: 'luxury-resale-authenticity',
    title: '二手奢侈品带货真假混卖？检测视频与转账记录',
    categoryId: 'commerce',
    evidence: ['video', 'transfer'],
    summary:
      '多名买家投稿称收到的商品与直播展示不符。投稿人提供了送检过程的完整视频与对应的付款记录，检测结论与卖家说法存在差异。',
    cover:
      'https://readdy.ai/api/search-image?query=elegant%20still%20life%20of%20a%20leather%20handbag%20and%20a%20magnifying%20glass%20on%20a%20dark%20walnut%20table%2C%20warm%20directional%20light%2C%20muted%20brown%20and%20gold%20tones%2C%20luxury%20editorial%20photography&width=800&height=450&seq=baoliao-luxury-resale&orientation=landscape',
    coverAlt: '二手奢侈品真伪争议相关的箱包与检测工具照片',
    author: '实锤整理组',
    publishDate: '2026-07-12',
    readTime: '5 分钟',
    views: '5.1 万',
    status: '待回应',
    featured: false,
    tags: ['真伪争议', '送检视频', '付款记录'],
    timeline: [
      { date: '2026-04', title: '直播成交', desc: '买家在直播中下单并完成付款。' },
      { date: '2026-05', title: '收到商品', desc: '买家认为商品与直播展示存在差异。' },
      { date: '2026-06', title: '送检', desc: '买家全程录像并委托第三方检测。' },
    ],
    evidenceItems: [
      { key: 'video', title: '送检全过程视频', desc: '记录开箱、封样与送检环节。', meta: '时长 8 分 45 秒' },
      { key: 'transfer', title: '付款记录', desc: '对应订单的付款金额与时间。', meta: '记录 2 笔' },
    ],
    related: ['c003', 'c007', 'c009'],
  },
  {
    id: 'c012',
    slug: 'fitness-course-refund',
    title: '健身达人课程退费难：付款截图与宣传承诺对照',
    categoryId: 'brand',
    evidence: ['transfer', 'video'],
    summary:
      '学员称课程宣传中的"随时退费"在实际申请时受阻。投稿人提供了付款截图与课程宣传视频片段，指出承诺条款与协议内容不一致。',
    cover:
      'https://readdy.ai/api/search-image?query=clean%20minimal%20scene%20with%20a%20water%20bottle%2C%20sneakers%20and%20a%20smartphone%20on%20a%20pale%20concrete%20floor%2C%20bright%20soft%20daylight%2C%20muted%20sage%20and%20stone%20tones%2C%20editorial%20still%20life&width=800&height=450&seq=baoliao-fitness-refund&orientation=landscape',
    coverAlt: '健身课程退费争议相关的付款记录与宣传视频画面',
    author: '实锤整理组',
    publishDate: '2026-07-06',
    readTime: '4 分钟',
    views: '4.4 万',
    status: '已核实',
    featured: false,
    tags: ['退费', '宣传承诺', '付款截图'],
    timeline: [
      { date: '2026-02', title: '购买课程', desc: '学员通过直播链接购买课程。' },
      { date: '2026-04', title: '申请退费', desc: '被告知不符合退费条件。' },
      { date: '2026-06', title: '材料投稿', desc: '学员整理付款与宣传材料。' },
    ],
    evidenceItems: [
      { key: 'transfer', title: '课程付款截图', desc: '显示订单金额与支付时间。', meta: '记录 1 笔' },
      { key: 'video', title: '宣传视频片段', desc: '包含"随时退费"的口播内容。', meta: '片段 55 秒' },
    ],
    related: ['c007', 'c009', 'c002'],
  },
];

export const hotRanking = [
  { id: 'c001', title: '美食博主分成纠纷三段录音公开' },
  { id: 'c002', title: '游戏主播转会费转账记录对不上' },
  { id: 'c003', title: '美妆直播"剧本式打假"逐帧对比' },
  { id: 'c004', title: 'MCN 拖欠分成七笔凭证汇总' },
  { id: 'c005', title: '探店账号数据异常与保底条款冲突' },
];

export const siteFaqs = [
  {
    q: '网站上的爆料内容是如何核实并发布的？',
    a: '每条爆料在发布前都会经过材料初审、关键信息比对与当事方回应三个环节。我们优先采信可与其他材料相互印证的原始录音、视频、合同照片与转账记录，并将核实状态标注在标题区域。',
  },
  {
    q: '为什么爆料中使用的是化名而不是真实姓名？',
    a: '为避免在核实完成前对任何个人造成不必要的困扰，站内对当事人统一使用化名与账号代称，同时对证件号、手机号、银行账号等隐私信息做遮挡处理。',
  },
  {
    q: '如何判断一条爆料属于"已核实"还是"待回应"？',
    a: '"已核实"表示核心材料已与其他来源交叉印证；"待回应"表示我们已经联系当事方但尚未收到回复；"审核中"表示材料仍在比对阶段，结论可能调整。',
  },
  {
    q: '普通用户可以提交自己的证据材料吗？',
    a: '可以。你可以通过"关于我们"页面的投稿入口提交材料说明与联系方式，我们会安排专人对接，并在发布前与你就材料范围达成一致。',
  },
  {
    q: '如果我对某条爆料有异议，该怎么处理？',
    a: '你可以通过站内联系邮箱提交异议说明与反证材料。收到后我们会暂停相关内容的推荐位，并在核实后更新页面标注或作撤稿处理。',
  },
];